// extracted by mini-css-extract-plugin
export default {"typing":"mwLDT","background":"_6uTcJ","content":"_1fm9l","wrapper":"_4pcKO","member":"a5N5h","separator":"_25gb8"};